import { useIntl } from 'react-intl';

import Image from '@/components/image/NextImage';
import { useFreeTrialClick } from '@/components/plans/hooks/useFreeTrialClick';
import GridWrapper from '@/components/ui/GridWrapper';

import { tiles } from './data';
import messages from './messages';
import { FeaturesButton, Heading, Tile, TileContent, Tiles, Wrapper } from './styles';

const Features = () => {
	const { formatMessage } = useIntl();

	const onFreeTrialClick = useFreeTrialClick();

	return (
		<Wrapper>
			<GridWrapper>
				<Heading>{formatMessage(messages.heading)}</Heading>
			</GridWrapper>
			<Tiles>
				{tiles.map(tile => (
					<Tile key={tile.alt}>
						<Image fill src={tile.src} alt={tile.alt} style={{ objectFit: 'cover' }} />
						<TileContent>{formatMessage(tile.copy)}</TileContent>
					</Tile>
				))}
			</Tiles>
			<FeaturesButton backgroundColor="gradientCalmBrand" textColor="white" onPress={onFreeTrialClick}>
				{formatMessage(messages.cta)}
			</FeaturesButton>
		</Wrapper>
	);
};

export default Features;
